// Dynamic discount codes configuration
export interface DiscountConfig {
  mentorSlug: string;
  code: string;
  discountedPrice: number;
  description: string;
}

export const DISCOUNT_CODES: DiscountConfig[] = [
  {
    mentorSlug: 'romankhan',
    code: 'roman10',
    discountedPrice: 1200,
    description: "Save 20% when you book with Roman's direct link.",
  },
  {
    mentorSlug: 'domeniciacovone',
    code: 'RAW20',
    discountedPrice: 3000,
    description: "Skip the waitlist and save 20% with Dom's link.",
  },
  {
    mentorSlug: 'kenny',
    code: 'kenny15',
    discountedPrice: 260,
    description: "Save 15% when you book with Kenny's direct link.",
  },
];

// Helper function to find applicable discount
export const findApplicableDiscount = (
  mentorSlug: string,
  code: string
): DiscountConfig | null => {
  return (
    DISCOUNT_CODES.find(
      (discount) =>
        discount.mentorSlug.toLowerCase() ===
          mentorSlug.toLowerCase() &&
        discount.code.toLowerCase() === code.toLowerCase()
    ) || null
  );
};

// Helper function to check if a mentor has any discount codes
export const getMentorDiscountCodes = (
  mentorSlug: string
): DiscountConfig[] => {
  return DISCOUNT_CODES.filter(
    (discount) =>
      discount.mentorSlug.toLowerCase() === mentorSlug.toLowerCase()
  );
};

// Helper function to get all available discount codes
export const getAllDiscountCodes = (): DiscountConfig[] => {
  return DISCOUNT_CODES;
};
